"use client";
import React from "react";
import dynamic from 'next/dynamic'
const MainPoster = dynamic(() => import('@/components/mainposter'))

export default function PrivacyPolicy() {

  return (
    <>
      <MainPoster
        bgimg="/assets/images/my-cart/bg/bg-poster.webp"
        title="Privacy Policy"
        type="pathes"
        main="Home"
        mainhref="/"
        sub="Privacy Policy"
        subhref="/privacy-policy"
      />

      <section className="section-py blog-bg-poster privacy-policy">
        <div className="container-main mx-auto px-3">
          <h2 className="fw-medium mb-4">Privacy Policy</h2>
          <p>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla
            accumsan, metus ultrices eleifend gravida, nulla nunc varius lectus,
            nec rutrum justo nibh eu lectus. Ut vulputate semper dui. Fusce erat
            odio, sollicitudin vel erat vel, interdum mattis neque.
          </p>
          <h3 className="mt-4 fw-medium">1. Information We Collect</h3>
          <p>
            Curabitur accumsan turpis pharetra augue tincidunt blandit. Quisque
            condimentum maximus mi, sit amet commodo arcu rutrum id. Proin
            pretium urna vel cursus venenatis. Suspendisse potenti. Etiam mattis
            sem rhoncus lacus dapibus facilisis.
          </p>
          <p>
            Maecenas ac lorem pretium, sagittis erat quis, malesuada elit. Cras
            fringilla convallis sem vel faucibus. Sed at nunc nec velit
            tincidunt elementum. Proin aliquet, odio id convallis blandit, nulla
            purus pretium diam, non tincidunt erat nulla eu sapien.
          </p>
          <h3 className="mt-4 fw-medium">2. How We Use Your Information</h3>
          <p>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi ut
            blandit risus. Donec mollis nec tellus et rutrum. Orci varius
            natoque penatibus et magnis dis parturient montes, nascetur
            ridiculus mus. Curabitur sagittis felis nec lacus finibus facilisis.
          </p>
          <h3 className="mt-4 fw-medium">3. Sharing of Information</h3>
          <p>
            Fusce a quam. Etiam ut purus mattis mauris sodales aliquam.
            Curabitur nisi. Quisque malesuada placerat nisl. Nam ipsum risus,
            rutrum vitae, vestibulum eu, molestie vel, lacus. Sed augue ipsum,
            egestas nec, vestibulum et, malesuada adipiscing, dui.
          </p>
          <h3 className="mt-4 fw-medium">
            4. Cookies and Tracking Technologies
          </h3>
          <p>
            Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque
            penatibus et magnis dis parturient montes, nascetur ridiculus mus.
            Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem.
            Nulla consequat massa quis enim.
          </p>

          <h3 className="mt-4 fw-medium">5. Your Choices</h3>
          <p>
            Pellentesque habitant morbi tristique senectus et netus et malesuada
            fames ac turpis egestas. In dui magna, posuere eget, vestibulum et,
            tempor auctor, justo. In ac felis quis tortor malesuada pretium.
          </p>

          <h3 className="mt-4 fw-medium">6. Data Security</h3>
          <p>
            Vestibulum fringilla pede sit amet augue. In turpis. Pellentesque
            posuere. Praesent turpis. Aenean posuere, tortor sed cursus feugiat,
            nunc augue blandit nunc, eu sollicitudin urna dolor sagittis lacus.
          </p>

          <h3 className="mt-4 fw-medium">7. Third-Party Links</h3>
          <p>
            Suspendisse feugiat. Suspendisse enim turpis, dictum sed, iaculis a,
            condimentum nec, nisi. Praesent id massa id nisl venenatis lacinia.
            Aenean sit amet justo. Vestibulum ullamcorper mauris at ligula.
          </p>

          <h3 className="mt-4 fw-medium">8. Children’s Privacy</h3>
          <p>
            Donec posuere vulputate arcu. Phasellus accumsan cursus velit. Lorem
            ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo
            ligula eget dolor. Aenean massa.
          </p>

          <h3 className="mt-4 fw-medium">9. Changes to This Policy</h3>
          <p>
            Donec vitae sapien ut libero venenatis faucibus. Nullam quis ante.
            Etiam sit amet orci eget eros faucibus tincidunt. Duis leo. Sed
            fringilla mauris sit amet nibh.
          </p>

          <h3 className="mt-4 fw-medium">10. Contact Us</h3>
          <p>
            If you have any questions or concerns regarding this privacy policy,
            please feel free to contact us at{" "}
            <a href="mailto:support@example.com">support@example.com</a>.
          </p>
        </div>
      </section>
    </>
  );
}
